import { logClientRuntimeError } from "./clientErrorLog";
function createFallbackCommissionRow() {
    return {
        orderNumber: "",
        orderName: null,
        orderDate: "",
        OrderPaidDate: null,
        CustomerName: "",
        CustomerId: "",
        SalesRepName: null,
        SalesRepId: null,
        CustomerEmail: "",
        subtotal: 0,
        commission: 0,
        TeamManagerCommission: 0,
        CommissionType: "",
        ProductTitle: "",
        OrderId: 0,
        total: 0,
        financial_status: null,
        fulfillment_status: null,
        TypeOfCustomer: null,
        DateOfFirstOrder: null,
        PartyId: 0,
        Discount: 0,
        FulfillmentDate: "",
        OrderStatus: "pending",
        b2BCompanyId: null,
        B2BCompanyName: null,
        b2BLocationId: null,
        B2BLocationName: null,
        isRefundedOrders: false,
    };
}
function pickStField(row, pascalKey, camelKey) {
    var _a;
    var camel = camelKey !== null && camelKey !== void 0 ? camelKey : pascalKey.charAt(0).toLowerCase() + pascalKey.slice(1);
    return (_a = row[pascalKey]) !== null && _a !== void 0 ? _a : row[camel];
}
/** Prefer normalised ST Reports `Status`, then common API aliases (some backends only send `OrderStatus` / financial fields). */
function pickStReportStatusRaw(row) {
    var candidates = [
        pickStField(row, "Status", "status"),
        pickStField(row, "OrderStatus", "orderStatus"),
        pickStField(row, "FinancialStatus", "financialStatus"),
        pickStField(row, "PaymentStatus", "paymentStatus"),
    ];
    for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
        var c = candidates_1[_i];
        if (c != null && String(c).trim() !== "") {
            return String(c);
        }
    }
    return "";
}
/** Map one `data=59` unified order row into the legacy commission / All-tab row shape. */
export function mapStReportApiRowToLegacyCommission(row) {
    var _a, _b, _c, _d, _e, _f, _g;
    try {
        var statusRaw = pickStReportStatusRaw(row);
        var normalizedStatus = statusRaw.toLowerCase().trim();
        var orderPaidRaw = pickStField(row, "OrderPaidDate", "orderPaidDate");
        var hasMeaningfulPaidDate = orderPaidRaw != null && String(orderPaidRaw).trim() !== "" && String(orderPaidRaw).trim() !== "-" && String(orderPaidRaw).toLowerCase() !== "null";
        var orderStatus = "pending";
        var isRefundedOrders = false;
        if (!normalizedStatus && hasMeaningfulPaidDate) {
            orderStatus = "paid";
        }
        else if (normalizedStatus === "paid" || normalizedStatus === "completed") {
            orderStatus = normalizedStatus === "completed" ? "completed" : "paid";
        }
        else if (normalizedStatus === "pending" || normalizedStatus === "unpaid") {
            orderStatus = "pending";
        }
        else if (normalizedStatus === "open" || normalizedStatus === "draft") {
            orderStatus = "open";
        }
        else if (normalizedStatus === "voided" || normalizedStatus === "partially_refunded" || normalizedStatus === "refunded") {
            orderStatus = normalizedStatus;
            isRefundedOrders = normalizedStatus === "refunded" || normalizedStatus === "partially_refunded";
        }
        var orderNum = pickStField(row, "OrderNumber", "orderNumber");
        var orderNumStr = orderNum != null ? String(orderNum) : "";
        var orderIdRaw = pickStField(row, "OrderId", "orderId");
        var parsedOrderId = typeof orderIdRaw === "number" ? orderIdRaw : parseInt(String(orderIdRaw !== null && orderIdRaw !== void 0 ? orderIdRaw : "0"), 10);
        var isDraftLike = orderStatus === "open" || orderStatus === "voided";
        return {
            orderNumber: orderNumStr,
            orderName: isDraftLike ? orderNumStr || null : null,
            orderDate: String((_a = pickStField(row, "OrderDate", "orderDate")) !== null && _a !== void 0 ? _a : ""),
            OrderPaidDate: String((_b = pickStField(row, "OrderPaidDate", "orderPaidDate")) !== null && _b !== void 0 ? _b : ""),
            CustomerName: String((_c = pickStField(row, "CustomerName", "customerName")) !== null && _c !== void 0 ? _c : ""),
            CustomerId: "",
            SalesRepName: null,
            SalesRepId: null,
            CustomerEmail: "",
            subtotal: Number((_d = pickStField(row, "Subtotal", "subtotal")) !== null && _d !== void 0 ? _d : 0),
            commission: Number((_e = pickStField(row, "Commission", "commission")) !== null && _e !== void 0 ? _e : 0),
            TeamManagerCommission: 0,
            CommissionType: String((_f = pickStField(row, "SalesMethod", "salesMethod")) !== null && _f !== void 0 ? _f : ""),
            ProductTitle: "",
            OrderId: Number.isFinite(parsedOrderId) && parsedOrderId > 0 ? parsedOrderId : 0,
            total: 0,
            financial_status: null,
            fulfillment_status: String((_g = pickStField(row, "FulfilmentStatus", "fulfilmentStatus")) !== null && _g !== void 0 ? _g : "") || null,
            TypeOfCustomer: null,
            DateOfFirstOrder: null,
            PartyId: 0,
            Discount: 0,
            FulfillmentDate: "",
            OrderStatus: orderStatus,
            b2BCompanyId: null,
            B2BCompanyName: (function () {
                var _a;
                var v = String((_a = pickStField(row, "CompanyName", "companyName")) !== null && _a !== void 0 ? _a : "");
                return v && v !== "-" ? v : null;
            })(),
            b2BLocationId: null,
            B2BLocationName: (function () {
                var _a;
                var v = String((_a = pickStField(row, "CompanyLocation", "companyLocation")) !== null && _a !== void 0 ? _a : "");
                return v && v !== "-" ? v : null;
            })(),
            isRefundedOrders: isRefundedOrders,
            RefundId: pickStField(row, "RefundId", "refundId") != null ? String(pickStField(row, "RefundId", "refundId")) : undefined,
            RefundApiOrderId: pickStField(row, "RefundApiOrderId", "refundApiOrderId") != null ? String(pickStField(row, "RefundApiOrderId", "refundApiOrderId")) : undefined,
        };
    }
    catch (error) {
        logClientRuntimeError("mapStReportApiRowToLegacyCommission", error);
        return createFallbackCommissionRow();
    }
}
/**
 * Turns unified `Orders` from GET `data=59` into the legacy GET `data=18` Redux slices
 * (`AllOrdersCommission`, `draftOrdersDetails`, `allRefundOrdersDetails`).
 */
export function splitSTOrderDetailsOrdersIntoLegacySlices(ordersRaw) {
    var _a, _b, _c, _d, _e, _f;
    var empty = function () { return ({ AllOrdersCommission: [], draftOrdersDetails: [], allRefundOrdersDetails: [] }); };
    try {
        if (!Array.isArray(ordersRaw)) {
            return empty();
        }
        var AllOrdersCommission = [];
        var draftOrdersDetails = [];
        var allRefundOrdersDetails = [];
        for (var _i = 0, ordersRaw_1 = ordersRaw; _i < ordersRaw_1.length; _i++) {
            var r = ordersRaw_1[_i];
            try {
                var row = mapStReportApiRowToLegacyCommission(r);
                var st = String((_a = row.OrderStatus) !== null && _a !== void 0 ? _a : "").toLowerCase();
                if (st === "open") {
                    draftOrdersDetails.push(row);
                    continue;
                }
                if (st === "refunded" || st === "voided" || st === "partially_refunded" || row.isRefundedOrders) {
                    var refundRow = {
                        orderId: String((_b = row.OrderId) !== null && _b !== void 0 ? _b : ""),
                        ShopName: "",
                        RefundId: (_c = row.RefundId) !== null && _c !== void 0 ? _c : "",
                        OrderDate: row.orderDate,
                        ShopifyOrderNumber: row.orderNumber,
                        OrderName: (_d = row.orderName) !== null && _d !== void 0 ? _d : "-",
                        Commission: row.commission,
                        TeamManagerCommission: (_e = row.TeamManagerCommission) !== null && _e !== void 0 ? _e : 0,
                        TeamManagerId: null,
                        SalesRepId: (_f = row.SalesRepId) !== null && _f !== void 0 ? _f : "",
                        RefundSubTotal: row.subtotal,
                        OrderStatus: row.OrderStatus,
                        OrderType: row.CommissionType,
                        ReferenceAffiliateCommission: 0,
                        ReferenceAffiliateId: null,
                    };
                    allRefundOrdersDetails.push(refundRow);
                    continue;
                }
                AllOrdersCommission.push(row);
            }
            catch (error) {
                logClientRuntimeError("splitSTOrderDetailsOrdersIntoLegacySlices.row", error);
            }
        }
        return { AllOrdersCommission: AllOrdersCommission, draftOrdersDetails: draftOrdersDetails, allRefundOrdersDetails: allRefundOrdersDetails };
    }
    catch (error) {
        logClientRuntimeError("splitSTOrderDetailsOrdersIntoLegacySlices", error);
        return empty();
    }
}
